import React from 'react';
import styled from 'styled-components';
import { Text, TextVariant } from '@naf/text';
import { Tooltip } from '@naf/parts';
export const Title = ({
  children,
  size = 'standard',
  toolTip,
  className
}) => {
  return /*#__PURE__*/React.createElement(TitleWrap, null, /*#__PURE__*/React.createElement(Text, {
    tag: "h5",
    variant: size === 'standard' ? TextVariant.Small : TextVariant.ArticleTextHeader,
    style: {
      margin: 0
    },
    className: className
  }, children), toolTip && /*#__PURE__*/React.createElement(Tooltip, {
    text: toolTip
  }));
};
export default Title;
const TitleWrap = styled.span.withConfig({
  displayName: "title__TitleWrap",
  componentId: "sc-14r89gr-0"
})(["display:flex;position:relative;flex-basis:100%;"]);
//# sourceMappingURL=title.js.map